<template>
  <v-container fluid class="main-invest-container">

    <div>      

      <v-layout row wrap mt-3>
        <v-flex xs12 pa-0>
          <v-tabs
            v-model="tab"
            background-color="transparent"
            color="basil"
            mt-2
          >
            <v-tab v-for="(tab, idx) in tabs" :key="idx" ripple>{{
              tab.name
            }}</v-tab>
            <v-tab-item v-for="(tab, idx) in tabs" :key="idx">
              <!-- TAB INFO -->
              <div v-if="tab.id == 'info'">
                <v-card class="pa-4">
                  <v-carousel
                    v-if="offer.package.investAbout.data.images"
                    cycle
                    height="350"
                    :show-arrows="
                      offer.package.investAbout.data.images.length < 2
                        ? false
                        : true
                    "
                    :hide-delimiters="
                      offer.package.investAbout.data.images.length < 2
                        ? true
                        : false
                    "
                  >
                    <v-carousel-item
                      v-for="(item, i) in offer.package.investAbout.data.images"
                      :key="i"
                      :src="getSrcImageFile(item.id)"
                      rreverse-transition="fade-transition"
                      ttransition="fade-transition"
                    ></v-carousel-item>
                  </v-carousel>

                  <div class="about-main">
                    <div>
                      <h2 class="mb-3">{{ $t('components.invest.info.description') }}</h2>
                      <div v-html="cInvestAbout"></div>
                    </div>
                    <div
                      v-if="offer.package.investAbout.data.options"
                      class="fly-panel"
                    >
                      <h2 class="mb-3">{{ $t('components.invest.info.parameters') }}</h2>
                      <table class="table-buisnes-options">
                        <tbody>
                          <tr
                            v-for="(option, indexOption) in offer.package
                              .investAbout.data.options"
                            :key="indexOption"
                          >
                            <td>{{ option.key }}</td>
                            <td>{{ option.value }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </v-card>
                <v-card
                  class="my-2 pa-4"
                  v-if="false"
                  vv-if="cIsEditValid"
                  elevation="8"
                >
                  <v-card-actions v-if="tab.editMode === true">
                    <v-btn
                      style="color: white"
                      :loading="tab.loading"
                      color="green"
                      @click="saveTabInvest(tab)"
                      >{{ $t('components.invest.info.actions.save') }}</v-btn
                    >

                    <v-btn
                      color="default"
                      outlined
                      @click="toggleEditModeTab(tab)"
                      >{{ $t('components.invest.info.actions.cancel') }}</v-btn
                    >
                  </v-card-actions>
                  <v-card-actions v-else>
                    <v-btn
                      style="color: white"
                      color="orange"
                      @click="toggleEditModeTab(tab)"
                      >{{ $t('components.invest.info.actions.edit') }}</v-btn
                    >
                  </v-card-actions>
                  <v-divider v-if="tab.editMode"></v-divider>
                  <wysiwyg
                    v-if="tab.editMode"
                    v-model="offer.package.investAbout.data.text"
                  ></wysiwyg>
                </v-card>
              </div>

              <!-- TAB BUISNES -->
              <div v-if="tab.id == 'buisnes'">
                <v-card class="pa-4">
                  <v-carousel
                    v-if="offer.package.investBusiness.data.images"
                    cycle
                    height="350"
                    :show-arrows="
                      offer.package.investBusiness.data.images.length < 2
                        ? false
                        : true
                    "
                    :hide-delimiters="
                      offer.package.investBusiness.data.images.length < 2
                        ? true
                        : false
                    "
                  >
                    <v-carousel-item
                      v-for="(item, i) in offer.package.investBusiness.data
                        .images"
                      :key="i"
                      :src="getSrcImageFile(item.id)"
                      rreverse-transition="fade-transition"
                      ttransition="fade-transition"
                    ></v-carousel-item>
                  </v-carousel>

                  <div class="buisnes-main">
                    <div>
                      <h2 class="mb-3">{{ $t('components.invest.info.buisnesMain') }}</h2>
                      <div
                        v-html="offer.package.investBusiness.data.text"
                      ></div>
                    </div>
                    <div
                      v-if="offer.package.investBusiness.data.options"
                      class="fly-panel"
                    >
                      <h2 class="mb-3">{{ $t('components.invest.info.buisnesOptions') }}</h2>
                      <table class="table-buisnes-options">
                        <tbody>
                          <tr
                            v-for="(option, indexOption) in offer.package
                              .investBusiness.data.options"
                            :key="indexOption"
                          >
                            <td>{{ option.key }}</td>
                            <td>{{ option.value }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </v-card>
                <v-card
                  class="my-2 pa-4"
                  v-if="false"
                  vv-if="cIsEditValid"
                  elevation="8"
                >
                  <v-card-actions v-if="tab.editMode === true">
                    <v-btn
                      style="color: white"
                      :loading="tab.loading"
                      color="green"
                      @click="saveTabInvest(tab)"
                      >{{ $t('components.invest.info.actions.save') }}</v-btn
                    >

                    <v-btn
                      color="default"
                      outlined
                      @click="toggleEditModeTab(tab)"
                      >{{ $t('components.invest.info.actions.cancel') }}</v-btn
                    >
                  </v-card-actions>
                  <v-card-actions v-else>
                    <v-btn
                      style="color: white"
                      color="orange"
                      @click="toggleEditModeTab(tab)"
                      >{{ $t('components.invest.info.actions.edit') }}</v-btn
                    >
                  </v-card-actions>
                  <v-divider v-if="tab.editMode"></v-divider>
                  <wysiwyg
                    v-if="tab.editMode"
                    v-model="offer.package.investBusiness.data.text"
                  ></wysiwyg>
                </v-card>
              </div>

              <!-- TAB BUISNES -->
              <div v-if="tab.id == 'documents'">
                <v-card class="pa-4">
                  <my-documents
                    :package-mode="offer.package.id"
                    :edit-mode="!isReadOnlyDocuments"
                    :documents-data="offer.package.documents.data"
                    vv-on:updateDocuments="updateDocuments"
                    v-on:updatePackageDocuments="updatePackageDocuments"
                    v-on:updateCustomPackageDocuments="
                      updateCustomPackageDocuments
                    "
                  />
                </v-card>
              </div>

              <!-- TAB FINANCE -->
              <div v-if="tab.id == 'finance'">
                <v-card class="pa-4">
                  <v-layout
                    fjustify-center
                    flex-wrap2
                    fill-height
                    class="finance-layout"
                  >
                    <div>
                      <table class="table-noborder">
                        <tbody>
                          <tr>
                            <td>{{ $t('components.invest.info.finance.client') }}</td>
                            <td>
                              {{
                                offer.package.clientCompany.data
                                  .organization_short_name
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('components.invest.info.finance.inn_ogrn') }}</td>
                            <td>
                              {{ offer.package.clientCompany.data.inn }}/{{
                                offer.package.clientCompany.data.ogrn
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('components.invest.info.finance.okved') }}</td>
                            <td>
                              <dadata-okved
                                :dadata="
                                  offer.package.clientCompany.data.dadata
                                "
                              ></dadata-okved>
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('components.invest.info.finance.address') }}</td>
                            <td>
                              {{
                                offer.package.clientCompany.data.dadata.address
                                  .value
                              }}
                            </td>
                          </tr>

                          <tr
                            v-if="
                              offer.package.clientCompany.data.dadata.capital
                            "
                          >
                            <td>
                              {{
                                offer.package.clientCompany.data.dadata.capital
                                  .type
                              }}{{ $t('components.invest.info.finance.capital') }}
                            </td>
                            <td>
                              {{
                                offer.package.clientCompany.data.dadata.capital
                                  .value | formatPrice
                              }}
                            </td>
                          </tr>
                          <tr>
                            <td>{{ $t('components.invest.info.finance.termActivity') }}</td>
                            <td>
                              c
                              {{
                                offer.package.clientCompany.data
                                  .organization_created_date | formatDate
                              }}
                              <v-chip
                                class="ml-2"
                                color="green lighten-2"
                                text-color="white"
                                v-if="
                                  offer.package.clientCompany.data.dadata.state
                                    .status == 'ACTIVE'
                                "
                                >{{ $t('components.invest.info.finance.statusCompany.active') }}</v-chip
                              >
                              <v-chip
                                class="ml-2"
                                color="orange lighten-3"
                                v-if="
                                  offer.package.clientCompany.data.dadata.state
                                    .status == 'REORGANIZING'
                                "
                                >{{ $t('components.invest.info.finance.statusCompany.reorganizing') }}</v-chip
                              >

                              <v-chip
                                class="ml-2"
                                color="red lighten-3"
                                text-color="white"
                                v-if="
                                  offer.package.clientCompany.data.dadata.state
                                    .status == 'LIQUIDATING'
                                "
                                >{{ $t('components.invest.info.finance.statusCompany.liquidating') }}</v-chip
                              >
                              <v-chip
                                class="ml-2"
                                color="red lighten-3"
                                text-color="white"
                                v-if="
                                  offer.package.clientCompany.data.dadata.state
                                    .status == 'LIQUIDATED'
                                "
                                >{{ $t('components.invest.info.finance.statusCompany.liquidated') }}</v-chip
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <v-divider vertical></v-divider>
                    <div>
                      <!-- <v-card
                        v-for="(founder, indFounder) in offer.package.clientCompany.data.dadata.founders"
                        :key="indFounder"
                        outlined
                      >-->
                      <v-list two-line>
                        <v-subheader>{{ $t('components.invest.info.finance.founders') }}</v-subheader>
                        <v-list-item
                          v-for="(founder, indFounder) in offer.package
                            .clientCompany.data.dadata.founders"
                          :key="indFounder"
                        >
                          <v-list-item-content v-if="founder.fio">
                            <v-list-item-title>{{
                              founder.fio.source
                            }}</v-list-item-title>
                            <v-list-item-subtitle>
                              <div v-if="founder.type == 'PHYSICAL'">
                                {{ $t('components.invest.info.finance.physicalFace') }}
                              </div>
                              <div v-else> {{ $t('components.invest.info.finance.companyFace') }}</div>
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action v-if="founder.share">
                            <v-list-item-action-text
                              >{{ $t('components.invest.info.finance.percent') }}</v-list-item-action-text
                            >
                            <span v-if="founder.share.type == 'PERCENT'"
                              >{{ founder.share.value }}%</span
                            >
                            <span v-else>{{ founder.share.value }}</span>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>

                      <!-- </v-card> -->
                    </div>
                  </v-layout>
                  <v-divider class="my-4"></v-divider>
                  <h4 class="my-3">
                    {{ $t('components.invest.info.finance.scoringTitle') }}
                  </h4>
                  <div class="main-info-wrap">
                    <div
                      class="main-info-item"
                      v-for="(item, idx) in offer.package.checkList.details"
                      :key="`chect_item_${idx}`"
                    >
                      <!-- <v-divider /> -->
                      <v-icon
                        :color="getChecklistStatus(item.status)"
                        size="20"
                        class="mr-1"
                        >{{ getChecklistIcon(item.status) }}</v-icon
                      >
                      <span :class="{ 'font-weight-bold': !item.status }">{{
                        item.prompt
                      }}</span>
                      <div v-if="item.children && item.children.length">
                        <div
                          v-for="(subItem, subIdx) in item.children"
                          :key="`chect_item_${idx}_${subIdx}`"
                          class="pl-3"
                        >
                          <v-icon
                            :color="getChecklistStatus(subItem.status)"
                            size="16"
                            class="mr-1"
                            >{{ getChecklistIcon(subItem.status) }}</v-icon
                          >
                          <span
                            :class="{ 'font-weight-bold': !subItem.status }"
                            >{{ subItem.prompt }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </v-card>
              </div>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </div>

   
  </v-container>
</template>

<script>
import { mapState } from "vuex";

import formatPrice from "@/mixins/filters/formatPrice";
import formatDate from "@/mixins/filters/formatDate";
import statusNames from "@/utils/data/statuses";
import MyDocuments from "@/components/clients/documents";
import DadataOkved from "@/components/dadata/okved";
import i18n from "@/services/i18n";

export default {
  name: "InvestInfo",
  //directives: { mask },
  mixins: [formatPrice, formatDate],
  data: () => ({   
    tab: 0,
    tabs: [
      { id: "info", name: i18n.t("components.invest.info.tabs.info"), editMode: false, loading: false },
      { id: "buisnes", name: i18n.t("components.invest.info.tabs.buisnes"), editMode: false, loading: false },
      { id: "documents", name:  i18n.t("components.invest.info.tabs.documents"), editMode: false, loading: false },
      { id: "finance", name:  i18n.t("components.invest.info.tabs.finance"), editMode: false, loading: false },
    ],
    statusNames,
  }),

  props: {
      offer: Object
  },
  components: {
    MyDocuments,
    DadataOkved,
  },

  computed: {
    ...mapState({
      userId: (state) => state.user.profile.id,
    }),
    cInvestAbout() {
      if (this.offer && this.offer.package && this.offer.package.investAbout) {
        if (this.offer.package.investAbout.data)
          return this.offer.package.investAbout.data.text;
      }
      return null;
    },

    cIsEditValid() {
      if (
        this.offer &&
        this.userId &&
        this.offer.package &&
        this.offer.package.user_id == this.userId
      ) {
        if (this.offer.status > 0) return false;
        return true;
      }

      return false;
    },

    isReadOnlyDocuments() {
      //return false;
      return true;
      // if(this.offer && this.userId && this.userId != this.offer.user_created)
      //   return false;
      // return true;
    },
  },

  methods: {
    getSrcImageFile(fileId) {
      return `${window.$api_url}v1/files/${fileId}/show-image`;
    },

    onEditOffer() {
      this.$router.push({ name: "InvestAddEdit", id: this.offer.id });
    },
    getChecklistIcon(status) {
      let output = null;

      switch (status) {
        case 0:
          output = "block";
          break;
        case 1:
          output = "check";
          break;
        case 2:
          output = "watch_later";
          break;
      }
      return output;
    },
    getChecklistStatus(status) {
      let output = null;

      switch (status) {
        case 0:
          output = "error";
          break;
        case 1:
          output = "success";
          break;
        case 2:
          output = "warning";
          break;
      }
      return output;
    },

    __findTabById(name) {
      for (let p in this.tabs) {
        if (this.tabs[p].id == name) return this.tabs[p];
      }
      return null;
    },
    updateCustomPackageDocuments(uploadedDocument) {
      if (!this.offer.package.documents.data[1].folders)
        this.offer.package.documents.data[1].folders = [];
      this.offer.package.documents.data[1].folders.push(uploadedDocument);
      let tab = this.__findTabById("documents");
      if (tab) this.saveTabInvest(tab, false);
    },
    updatePackageDocuments(uploadedDocument) {
      this.offer.package.documents.data.forEach((folder) => {
        if (folder.folders) {
          folder.folders.forEach((file) => {
            if (file.id === uploadedDocument.folder_id) {
              file.document = {};
              Object.assign(file.document, uploadedDocument);
            }
          });
        }
      });

      let tab = this.__findTabById("documents");
      if (tab) this.saveTabInvest(tab, false);
    },


    getStatusUserName(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].name
        ? this.statusNames.investUserDefault[id].name
        : "";
    },
    getStatusUserColor(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].color
        ? this.statusNames.investUserDefault[id].color
        : "";
    },
    getStatusUserTextColor(id) {
      if (!id) return;
      if (!this.statusNames) return;
      return this.statusNames.investUserDefault[id].textColor
        ? this.statusNames.investUserDefault[id].textColor
        : "";
    },
    onBackLink() {
      this.$router.push({ name: "Invest" });
    },
   
  },
  mounted() {
    
  },
};
</script>

<style lang="scss" scoped>

.main-invest-container {
  .v-list.danse__list_item {
    > .v-list-item {
      min-height: 30px;
    }
  }
}
.about-main,
.buisnes-main {
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-top: 20px;
}
.about-main > div:first-child,
.buisnes-main > div:first-child {
  flex-grow: 1;
  padding-right: 10px;
}

.about-main > div:last-child,
.buisnes-main > div:last-child {
  min-width: 364px;
}
.fly-panel {
  top: 0;
  position: sticky;
}
table.table-buisnes-options {
  width: 100%;
  border-collapse: collapse;
}

table.table-buisnes-options tr {
  border-top: 1px solid #d8d8d8;
}

table.table-buisnes-options tr:nth-child(2n-2) {
  background-color: #fbfbfb;
}

.finance-layout > div {
  width: 50%;
}

.finance-layout table > tbody > tr > td:first-child {
  min-width: 185px;
}

.main-info-wrap {
  columns: 2;
  > .main-info-item {
    opacity: 1;
  }
  // padding: 16px;
  // text-align: left;
  // display: flex;
  // flex-wrap: wrap;
  // h2 {
  //   min-width: 100%;
  //   width: 100%;
  // }

  // &--compact {
  //   background: #fff;
  //   padding: 16px;
  //   border-radius: 5px;
  //   box-shadow: 0 0 10px #aaa;

  //   .main-info-item {
  //     max-width: 100%;
  //     flex-basis: 100%;
  //   }
  //   .main-info-wrap {
  //     padding-top: 8px;
  //   }
  // }

  // .v-divider {
  //   margin: 8px 0;
  // }

  // &-wrap {
  //   display: flex;
  //   flex-wrap: wrap;
  //   padding-top: 24px;
  // }

  // &-item {
  //   max-width: 49%;
  //   min-width: 49%;

  //   &:nth-child(2n + 2) {
  //     margin-left: 2%;
  //   }
  // }
}

@media screen and (max-width: 1200px) {
  .finance-layout {
    flex-wrap: wrap;
  }
  .finance-layout > div {
    width: 100%;
  }
}
</style>
